import React from 'react';
import PropTypes from 'prop-types';
import useRelationship from 'Hooks/useRelationship';
import DataContainer from 'Components/UI/DataContainer';
import { ActivityTabs } from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/ActivityTabs';

const ActivityContainer = ({ relationship }) => {
  const {
    isInitializing,
    loadingError,
    collection,
  } = useRelationship(
    relationship,
  );

  let activityResource;
  if (collection) {
    activityResource = collection.resources().head();
  }

  return (
    <DataContainer
      component={ActivityTabs}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        resource: activityResource,
      }}
    />
  );
};

ActivityContainer.defaultProps = {};

ActivityContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export { ActivityContainer };
